<template>
    <NuxtLayout name="malt-full-layout">
        <main>
            <NuxtPage />
        </main>
        <template #admin-tools>
            <FooterAdminTools>
                <template #cta>
                    <LinkProjectWidget />
                </template>
            </FooterAdminTools>
        </template>
    </NuxtLayout>
</template>

<script setup lang="ts">
    import LinkProjectWidget from '@components/my-referrals/LinkProjectWidget.vue';
    import {storeToRefs} from 'pinia';
    import {NuxtPage, FooterAdminTools} from '#components';
    import {useAsyncData} from '#imports';
    import {usePreferencesStore, useReferralsStore} from '@/stores';

    const preferencesStore = usePreferencesStore();
    const {preferences} = storeToRefs(preferencesStore);
    await useAsyncData(async () => await preferencesStore.fetchBusinessReferralWebPreferences(), {deep: true});

    const {openHowItWorksModal} = useReferralsStore();
    openHowItWorksModal(!preferences.value.onboardingAcknowledged);
</script>
